import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Card, Button, Select, DatePicker, Modal } from 'antd';
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons';
import '../style/style.css'
import moment from 'moment';
import xlsx from 'xlsx'
const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const HeaderMutliApprove = ({
  columns,
  selectedColumn,
  dataHeader,
  finalData,
  lov = { awbNo: [], claimNumber: [], coverLetterNo: [], skpPrincipalNo: [] },
  stickyHeader,
  search,
  submit,
  dataProps
}) => {
  const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.dataIndex));
  const [coverLetterNoState, setCoverLetterNo] = useState("")
  const [skpPrincipalNo, setSkpPrincipalNo] = useState("")
  const [claimNumber, setClaimNumber] = useState("")
  const [awbNo, setAwbNo] = useState("")
  const [date, setDate] = useState('')
  const [showScroll, setShowScroll] = useState(false)
  const [showFillter, setShowFilter] = useState(true)
  // const [dataToSubmit, setDataToSubmit] = useState([])
  let dataToSubmit = []
  let dataError = []

  const handleColumnSelect = (value) => {
    setSelectedColumns(value);
    value.filter((column) => selectedColumns.includes(column));
    selectedColumn(value)
  };

  const handleSearch = () => {
    const param = {
      "cover_letter_no": coverLetterNoState,
      "claim_number": claimNumber,
      "ref_skp_principal_number": skpPrincipalNo,
      "awb_no": awbNo,
      "start_claim_exp_date": date && date[0] !== '' ? moment(date[0]).format("YYYY-MM-DD") : '',
      "end_claim_exp_date": date && date[1] !== '' ? moment(date[1]).format("YYYY-MM-DD") : ''
    }
    search(param)
  }

  const validate = () => {
    let valid = true
    var trueStatus = finalData.filter(function (item) {
      return item.reject || item.revise || item.approve;
    });

    dataToSubmit = trueStatus
    var dataGagalValidasi = [];

    trueStatus.forEach(function (item) {
      if (item.revise && item.reason === "") {
        dataGagalValidasi.push(item);
        valid = false
      }

      if (item.reject && item.reason === "") {
        dataGagalValidasi.push(item);
        valid = false
      }
    });

    dataError = dataGagalValidasi
    // setDataError(dataGagalValidasi)
    return valid
  }

  const validateData = () => {
    let isValidationError = true;

    // Validasi apakah salah satu dari total nilai lebih besar dari nol
    if (dataHeader.totalApprove > 0 || dataHeader.totalReject > 0 || dataHeader.totalRevise > 0) {
      isValidationError = false;
    }

    return isValidationError;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      warning()
    } else {
      confirm()
    }
  }

  useEffect(() => {
    stickyHeader(showFillter)
  }, [showFillter])


  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 150) {
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 150) {
      setShowScroll(false)
      setShowFilter(true)
    }
  };

  window.addEventListener('scroll', checkScrollTop)

  const warning = () => {
    Modal.error({
      title: 'Error',
      content: (
        <>
          {
            dataError.map((value, index) => {
              return (
                <p className='mb-0'> Claim Number= {value.claim_number} Reason  belum diisi</p>
              )
            })
          }
        </>
      ),
      zIndex: 1004
    });
  };

  const confirm = () => {
    Modal.confirm({
      title: 'Submit',
      content: (
        <>
          <p className='mb-0'><b>Approve : {dataHeader.totalApprove}</b></p>
          <p className='mb-0'><b>Revise :  {dataHeader.totalRevise}</b></p>
          <p className='mb-0'><b>Reject : {dataHeader.totalReject}</b></p>
        </>
      ),
      zIndex: 1004,
      onOk: () => {
        submit(dataToSubmit)
      }
    });
  };

  const exportToXlsx = () => {
    const newMaping = dataProps && dataProps.length ? dataProps.map((value, index) => {
      return {
        "APPROVE": null,
        "REVISE":null,
        "REJECT":null,
        "REASON":null,
        "COVER LETTER NO": value.cover_letter_no,
        "CLAIM NUMBER": value.claim_number,
        "REF NO": value.ref_no,
        "CUSTOMER NAME": value.customer_name,
        "PROGRAM TYPE": value.program_type,
        "DPP": value.dpp,
        "PPN": value.ppn,
        "TOTAL CLAIM": value.total_claim,
        "PPH RATE": value.pph_rate,
        "PPH": value.pph,
        "NET CLAIM": value.nett_claim,
      }
    }) : []

    const workBook = xlsx.utils.book_new(); // create a new blank book
    const workSheet = xlsx.utils.json_to_sheet(newMaping);
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    xlsx.writeFile(workBook, "Data multi approval.xlsx"); // initiate a file download in browser
  }
  return (
    <>
      {
        showFillter ?
          <DownCircleOutlined className="pinTop"
            onClick={() => {
              setShowFilter(!showFillter)
            }}
            style={{ height: 29, display: showScroll ? 'flex' : 'none' }} />
          :
          <UpCircleOutlined className="pinTop"
            onClick={() => {
              setShowFilter(!showFillter)
            }}
            style={{ height: 29, display: showScroll ? 'flex' : 'none' }} />
      }

      <div style={{ position: 'sticky', top: 0, width: '100%', zIndex: 1001 }}>
        <Card style={{ display: `${showFillter ? 'grid' : 'none'}` }}>
          <Row gutter={34}>
            <Col span={8}>
              <Row>
                <Col span={10} className='d-flex align-items-center'>
                  <Text >Cover Letter No </Text>
                </Col>
                <Col span={14}>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="Select cover letter"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={coverLetterNoState}
                    onChange={(e) => { setCoverLetterNo(e) }}
                  >
                    <Option value={""}>All Cover Letter</Option>
                    {
                      lov.coverLetterNo ? lov.coverLetterNo.map((value, index) => {
                        return (
                          <Option key={index} value={value.cover_letter_no}>
                            {value.cover_letter_no}
                          </Option>
                        )
                      }) : null
                    }
                  </Select>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col span={10} className='d-flex align-items-center'>
                  <Text >Claim No </Text>
                </Col>
                <Col span={14}>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="Select claim number"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={claimNumber}
                    onChange={(e) => { setClaimNumber(e) }}
                  >
                    <Option value={""}>All Claim Number</Option>
                    {
                      lov.claimNumber ? lov.claimNumber.map((value, index) => {
                        return (
                          <Option key={index} value={value.claim_number}>
                            {value.claim_number}
                          </Option>
                        )
                      }) : null
                    }
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row>
                <Col span={10} className='d-flex align-items-center'>
                  <Text >Ref/SKP Principal No </Text>
                </Col>
                <Col span={14}>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="Select ref/skp"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={skpPrincipalNo}
                    onChange={(e) => { setSkpPrincipalNo(e) }}
                  >
                    <Option value={""}>All ref/skp</Option>
                    {
                      lov.skpPrincipalNo ? lov.skpPrincipalNo.map((value, index) => {
                        return (
                          <Option key={index} value={value.ref_skp_principal_number}>
                            {value.ref_skp_principal_number}
                          </Option>
                        )
                      }) : null
                    }
                  </Select>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col span={10} className='d-flex align-items-center'>
                  <Text >AWB No </Text>
                </Col>
                <Col span={14}>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    placeholder="Select awb"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={awbNo}
                    onChange={(e) => { setAwbNo(e) }}
                  >
                    <Option value={""}>All awb</Option>
                    {
                      lov.awbNo ? lov.awbNo.map((value, index) => {
                        return (
                          <Option key={index} value={value.awb_no}>
                            {value.awb_no}
                          </Option>
                        )
                      }) : null
                    }
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row>
                <Col span={10} className='d-flex align-items-center'>
                  <Text >Claim Exp Date </Text>
                </Col>
                <Col span={14}>
                  <RangePicker
                    style={{ width: '100%' }}
                    disabledDate={false}
                    allowClear={true}
                    onChange={(date, string, instance) => {
                      setDate(string)
                    }} />
                </Col>
              </Row>
              <Row className='mt-4'>
                <Col span={24} className='d-flex justify-content-center'>
                  <Button type='primary' onClick={() => handleSearch()} className='w-100'>Search</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Card>
          {/* <Card> */}
          <Row gutter={24}>
            <Col span={10} className="d-flex">
              <Row className='w-100'>
                <Col span={6} className='d-flex align-items-center'>
                  <div><Text >Show Column </Text></div>
                </Col>
                <Col span={14}>
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select columns"
                    onChange={handleColumnSelect}
                    value={selectedColumns}
                    maxTagCount='responsive'
                  >
                    {columns.map((column) => (
                      <Option disabled={["no", "approve", "revise", "reject", "reason", "action"].includes(column.dataIndex) ? true : false} key={column.dataIndex} value={column.dataIndex}>
                        {column.title}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>

            <Col span={4} className="d-flex justify-content-center">
              <Button disabled={dataProps && dataProps.length ? false : true} onClick={() => exportToXlsx()}>Export To XLSX</Button>
            </Col>

            <Col span={10} className="w-100 d-flex justify-content-end">
              <Row gutter={10} className="w-100 d-flex justify-content-end mr-4">
                <Col span={8} className="w-100 d-flex justify-content-end">
                  <div>
                    <p className='mb-0'><b>Approve : {dataHeader.totalApprove}</b></p>
                    {/* <Popover content={content} title="Title" trigger="click">
                    <WarningOutlined style={{ color: 'red' }} />
                  </Popover> */}
                  </div>
                </Col>
                <Col span={8} className="w-100 d-flex justify-content-end">
                  <div>
                    <p className='mb-0'><b>Revise :  {dataHeader.totalRevise}</b></p>
                    {/* <Popover content={content} title="Title" trigger="click">
                    <WarningOutlined style={{ color: 'red' }} />
                  </Popover> */}
                  </div>
                </Col>
                <Col span={8} className="w-100 d-flex justify-content-end">
                  <div>
                    <p className='mb-0'><b>Reject : {dataHeader.totalReject}</b></p>
                    {/* <Popover content={content} title="Title" trigger="click">
                    <WarningOutlined style={{ color: 'red' }} />
                  </Popover> */}
                  </div>
                </Col>
              </Row>
              {/* <p className='mr-3'>
              <b>Approve : {dataHeader.totalApprove}</b>
              {' | '}
              <b>Revise :  {dataHeader.totalRevise}</b>
              {' | '}
              <b>Reject : {dataHeader.totalReject}</b>
            </p> */}
              <Button disabled={validateData()} type='primary' style={{ width: "150px" }} onClick={() => handleSubmit()}>Submit</Button>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  )
}

export default HeaderMutliApprove